function appendUniquePart(parts, value) {
  const next = String(value || "").trim();
  if (!next) return;
  const joined = parts.join(", ").toLowerCase();
  if (!joined.includes(next.toLowerCase())) parts.push(next);
}

export function formatStructuredAddress(parts) {
  const ordered = [];
  appendUniquePart(ordered, parts.houseNo);
  appendUniquePart(ordered, parts.street);
  appendUniquePart(ordered, parts.locality);
  appendUniquePart(ordered, parts.city);
  appendUniquePart(ordered, parts.state);
  appendUniquePart(ordered, parts.pincode);
  return ordered.join(", ");
}

/** Best-effort reverse geocoding via OpenStreetMap Nominatim. */
export async function reverseGeocodeAddress({ latitude, longitude }) {
  try {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${encodeURIComponent(
      latitude
    )}&lon=${encodeURIComponent(longitude)}`;

    const res = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "User-Agent": "nemaCare-app",
      },
    });
    if (!res.ok) return null;

    const json = await res.json();
    const addr = json?.address || {};

    const city =
      addr.city ||
      addr.town ||
      addr.village ||
      addr.municipality ||
      addr.state_district ||
      "";

    const state = addr.state || "";
    let houseNo = addr.house_number || "";
    let street =
      addr.road ||
      addr.pedestrian ||
      addr.footway ||
      addr.residential ||
      "";
    let locality =
      addr.suburb ||
      addr.neighbourhood ||
      addr.quarter ||
      addr.hamlet ||
      addr.city_district ||
      addr.place ||
      "";

    if (!street || !locality) {
      const display = String(json?.display_name || "");
      const segments = display
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const skip = new Set(
        [city, state, addr.postcode, addr.county, "India"].filter(Boolean).map((s) =>
          String(s).toLowerCase()
        )
      );
      const useful = segments.filter((seg) => !skip.has(seg.toLowerCase()));
      if (!houseNo && useful[0] && /^\d/.test(useful[0])) {
        houseNo = useful[0];
        useful.shift();
      }
      if (!street && useful[0]) {
        street = useful[0];
        useful.shift();
      }
      if (!locality && useful[0]) {
        locality = useful[0];
      }
    }

    const structured = {
      houseNo,
      street,
      locality,
      city,
      state,
      pincode: addr.postcode || "",
    };

    return {
      address: formatStructuredAddress(structured) || json?.display_name || "",
      ...structured,
    };
  } catch {
    return null;
  }
}
